import { render, staticRenderFns } from "./CpptRalanPage.vue?vue&type=template&id=67e4c7f7&scoped=true&"
import script from "./CpptRalanPage.vue?vue&type=script&lang=ts&"
export * from "./CpptRalanPage.vue?vue&type=script&lang=ts&"
import style0 from "./CpptRalanPage.vue?vue&type=style&index=0&id=67e4c7f7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e4c7f7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBtn,VCol,VRow,VTab,VTabs})
